export default "__VITE_ASSET__DuaB5xSN__"